export default function truncateWorkTitle(s: string, wordCount = 5): string {
  const splitString = s.replace(/\s+/g, ' ').split(/(?=\s)/gi);
  let truncated = splitString.slice(0, wordCount).join('');
  // Add ellipses if the title was longer than wordCount
  if (splitString.length > wordCount) {
    truncated += '...';
  }

  return truncated;
}
